;
/*!
 * subitotexto.effects.rain.js
 */
SubitoTexto.effects.rain = {
	init      : function () {

		var $ = jqPla,
			_this = SubitoTexto.effects.rain;

		_this.howManyDesktop = 250;
		_this.howManyMobile = 50;
		_this.howLongMs = 2000;
		_this.numDropTypes = 5;
		_this.numPlanes = 5;

	},

	launch: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.rain;

		SubitoTexto.effects.currentlyPlaying = true;

		_this.$effectFrame = $( '<div class="effects rain" />' ).appendTo( $('body') );

		var windowWidth = _this.$effectFrame.width(),
			howMany = $(window).width() < 1125 ? _this.howManyMobile : _this.howManyDesktop; // decided against areWeMobile() so that ipad Landscape would still only get a few

		var htmlToAdd = '';
		for ( var i = 0; i < howMany; i++ ) {

			var htmlDrop = '<div class="rain-drop';

			// drop type
			htmlDrop += ' rain-drop-' + PLA.UTILS.getRandomIntInclusive (1, _this.numDropTypes) + ' ';

			// drop plane
			htmlDrop += ' rain-plane-' + PLA.UTILS.getRandomIntInclusive (1, _this.numPlanes) + ' ';

			// end classes
			htmlDrop += '" ';

			// start style
			htmlDrop += ' style="';

			htmlDrop += 'left: ' + PLA.UTILS.getRandomIntInclusive (0, 100) + '%;';

			htmlDrop += 'animation-delay: ' + PLA.UTILS.getRandomIntInclusive (0, 1000) + 'ms;';

			// end style
			htmlDrop += ' " ';


			htmlDrop += '></div>';

			htmlToAdd += htmlDrop;
		}


		_this.$drops = $( htmlToAdd ).appendTo( _this.$effectFrame );



		setTimeout(function() {
			_this.$effectFrame.fadeOut(function() {
				$(this).remove();
				SubitoTexto.nepastoucheranimation.handleComplete(1, 0, 0);

				SubitoTexto.effects.currentlyPlaying = false;
			});

		}, _this.howLongMs)
	}
};